import React, { useContext, useEffect, useState } from 'react'
import { RemoveCourse } from '../../../components/exl/CourseHelperFunctions';
import DuplicateCourse from '../../../components/exl/DuplicateCourse';
import EditCourse from '../../../components/exl/EditCourse';
import Loading from '../../../components/Loading';
import CourseDetailsBody from './course-details-body/course-details-body';
import CourseDetailsHeader from './course-details-header/course-details-header';
import useCourseDetails from './use-course-details';
import { DataContext as SharedDataContext } from '../../../stores/crm-store';
import CustomModal from '../../../components/tables/shared/CustomModal';
import AddLecture from '../../../components/exl/AddLecture';
import ExlToasts from '../../../components/crm/shared/ExlToasts';
import EditCourseBookings from '../../../components/exl/edit-course-bookings/edit-course-bookings';
import EmailBookings from '../../../components/exl/EmailBookings';
import { useTranslation } from 'react-i18next';
import { COURSE_DETAILS_DELETE_COURSE_WARN, DELETE, COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_LABEL, COURSE_DETAILS_HEADER_EMAIL_RESERVE_BOOKINGS_LABEL } from '../../../i18n/keyConstants';
import { bookingStatusOptions } from '../../../components/exl/shared/translations';


export default function CourseDetails({ id: courseId }) {
    const [editCourseModalOpen, setEditCourseModalOpen] = useState(false);
    const [duplicateCourseModalOpen, setDuplicateCourseModalOpen] = useState(false);
    const [deleteCourseModalOpen, setDeleteCourseModalOpen] = useState(false);
    const [addLectureModalOpen, setAddLectureModalOpen] = useState(false);
    const [editBookingsModalOpen, setEditBookingsModalOpen] = useState(false);
    const [emailConfirmedBookingsModalOpen, setEmailConfirmedBookingsModalOpen] = useState(false);
    const [emailReserveBookingsModalOpen, setEmailReserveBookingsModalOpen] = useState(false);
    const [isRemoving, setIsRemoving] = useState();
    const { t } = useTranslation(['courseDetails', 'shared']);

    const { dispatch: sharedDispatch } = useContext(SharedDataContext);


    const handleRemoveCourse = async (courseId, sharedDispatch) => {
        setIsRemoving(true);
        await RemoveCourse(courseId, sharedDispatch);
        setIsRemoving(false);
    }

    const {
        course,
        loading,
        courseUser,
        cancelledBookings,
        refreshCourseData
    } = useCourseDetails(courseId);

    const confirmedBooking = bookingStatusOptions.Confirmed.value;
    const reserveBooking = bookingStatusOptions.Reserve.value;
    const confirmedParticipants = course?.bookings?.filter((booking) => booking.status === confirmedBooking);
    const reserveParticipants = course?.bookings?.filter((booking) => booking.status === reserveBooking);

    return (
        <>
            {loading && (
                <Loading />
            )}

            {!loading && course && (
                <div style={{ maxWidth: "1200px", margin: "0px auto", padding: "24px" }}>
                    <CourseDetailsHeader
                        course={course}
                        courseUser={courseUser}
                        refreshCourseData={refreshCourseData}
                        setEditCourseModalOpen={setEditCourseModalOpen}
                        setDuplicateCourseModalOpen={setDuplicateCourseModalOpen}
                        setDeleteCourseModalOpen={setDeleteCourseModalOpen}
                        setAddLectureModalOpen={setAddLectureModalOpen}
                        setEditBookingsModalOpen={setEditBookingsModalOpen}
                        setEmailConfirmedBookingsModalOpen={setEmailConfirmedBookingsModalOpen}
                        setEmailReserveBookingsModalOpen={setEmailReserveBookingsModalOpen}
                        confirmedParticipants={confirmedParticipants}
                        reserveParticipants={reserveParticipants}
                    />
                    <CourseDetailsBody
                        course={course}
                        courseUser={courseUser}
                        cancelledBookings={cancelledBookings}
                    />
                </div>
            )}

            {!loading && course && courseUser && (
                <>
                    {editCourseModalOpen && (
                        <EditCourse
                            open={editCourseModalOpen}
                            onClose={() => setEditCourseModalOpen(false)}
                            updateCourse={course}
                            submitHandler={refreshCourseData}
                            permissionRole={(
                                courseUser.teacherPermission &&
                                !courseUser.editPermission) ? "teacher"
                                : undefined
                            }
                        />
                    )}

                    {duplicateCourseModalOpen && (
                        <DuplicateCourse
                            updateCourse={course}
                            open={duplicateCourseModalOpen}
                            onClose={() => setDuplicateCourseModalOpen(false)}
                        />
                    )}

                    {addLectureModalOpen && (
                        <AddLecture
                            parentCourse={course}
                            open={addLectureModalOpen}
                            onClose={setAddLectureModalOpen}
                        />
                    )}

                    <CustomModal
                        show={deleteCourseModalOpen}
                        onHide={() => { setDeleteCourseModalOpen(false) }}
                        modalText={t(COURSE_DETAILS_DELETE_COURSE_WARN)}
                        buttonText={t(DELETE, { ns: 'shared' })}
                        handleModal={() => { handleRemoveCourse(course.id, sharedDispatch) }}
                        modalVariant='danger'
                        isSaving={isRemoving}
                        buttonClassName="btn btn-danger"
                    />

                    {editBookingsModalOpen && (
                        <EditCourseBookings
                            course={course}
                            open={editBookingsModalOpen}
                            refreshCourseData={refreshCourseData}
                            onClose={() => setEditBookingsModalOpen(false)}
                        />
                    )}
                    {emailConfirmedBookingsModalOpen && (
                        <EmailBookings
                            recipients={confirmedParticipants}
                            open={emailConfirmedBookingsModalOpen}
                            description={t(COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_LABEL, { ns: 'courseDetailsHeader' })}
                            onClose={() => setEmailConfirmedBookingsModalOpen(false)}
                            submitHandler={refreshCourseData}
                        />
                    )}
                    {emailReserveBookingsModalOpen && (
                        <EmailBookings
                            recipients={reserveParticipants}
                            open={emailReserveBookingsModalOpen}
                            description={t(COURSE_DETAILS_HEADER_EMAIL_RESERVE_BOOKINGS_LABEL, { ns: 'courseDetailsHeader' })}
                            onClose={() => setEmailReserveBookingsModalOpen(false)}
                            submitHandler={refreshCourseData}
                        />
                    )}

                    <ExlToasts />
                </>
            )}
        </>
    )
}
